import axios from 'axios';
import { getField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    actionIndicators: [],
    indicatorName: null,
    indicatorData: {
      key: null,
      value: null,
      period: null,
      range: {
        start: null,
        end: null,
        selected: null,
      },
    },
  },

  mutations: {
    GET_INDICATORS: (state, response) => {
      state.actionIndicators = response;
    },
  },

  getters: {
    getField,
  },

  actions: {
    async setIndicators(commit, obj) {
      await axios.post(
        `${process.env.API_ROOT}/indicator/${obj.actionId}/${obj.companyId}`,
        { ...obj.data },
        {
          headers: { 'x-access-token': obj.token },
        },
      );
    },

    async getIndicators({ commit }, obj) {
      const response = await axios.get(
        `${process.env.API_ROOT}/indicator/${obj.actionId}`,
        {
          headers: { 'x-access-token': obj.token },
        },
      );

      commit('GET_INDICATORS', response.data);
    },

    async addTypeToIndicator(commit, obj) {
      if (window.event.type === 'change') {
        await axios.put(
          `${process.env.API_ROOT}/indicator/add-type/${obj.indicatorId}`,
          { type: obj.type },
          {
            headers: { 'x-access-token': obj.token },
          },
        );
      }
    },

    async removeTypeFromIndicator(commit, obj) {
      if (window.event.type === 'change') {
        await axios.put(
          `${process.env.API_ROOT}/indicator/remove-type/${obj.indicatorId}`,
          { type: obj.type },
          {
            headers: { 'x-access-token': obj.token },
          },
        );
      }
    },

    async sortIndicator({ commit }, obj) {
      await axios.put(
        `${process.env.API_ROOT}/indicator/sort-indicator/${obj.companyId}`,
        { indicators: obj.indicators },
        {
          headers: { 'x-access-token': obj.token },
        },
      );
    },

    async deleteIndicator(commit, obj) {
      await axios.delete(
        `${process.env.API_ROOT}/indicator/${obj.indicatorId}`,
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/indicators/index.js